// extracted by mini-css-extract-plugin
module.exports = {"upgradeInDingDingContent":"style_upgradeInDingDingContent__fhceN","des":"style_des__F2qAg"};